var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "france") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 10,
    cy: 10,
    r: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "france",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ED2939",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: -5.13493431,
    y: 8.8817842e-15,
    width: 30.2698686,
    height: 20.1799124
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: -6.13493431,
    y: 8.8817842e-15,
    width: 20.1799124,
    height: 20.1799124
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#002395",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: -4.13493431,
    y: 8.8817842e-15,
    width: 10.0899562,
    height: 20.1799124
  })), /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_France",
    transform: "translate(-5.134934, 0.000000)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.2ccdfbdc613d6cbad4633d9971dc6337.svg";
export { ForwardRef as ReactComponent };